module.exports = __webpack_public_path__ + "img/case1.da39f2e2.png";